import { useState } from 'react'; 
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersUpdateType3 } from '../../../adminSlice';

const InputFormsForAnswersType3  = (props) => {

            

            const [userInputContent, setUserInputContent] = useState('');

            const [userInputValue, setUserInputValue] = useState(null);
            

    const { dispatch } = props;
  
 // CLICK OK
const onSend = () =>  {
        

        const item = {
            answer_id: props.adminState.selectedId,
            answer_content: userInputContent,
            answer_right: Number(userInputValue),
           
        }
        dispatch(idAnswersUpdateType3(item));  
}
// ENTER INPUT
const handleUserInputContent = (e) => {

            setUserInputContent(e.target.value);

}
const handleUserInputValue = (e) => {

            setUserInputValue(e.target.value);

}


// CLOSE FORM
const onClose = () => {
   
    dispatch(closeInputForms());

}

        return(
            <div className="InputFormsForQuizes">
                <p >Изменить ответ:</p>
                <p className="p-text">id: {props.adminState.selectedId}</p>
                <p className="p-text">Старый ответ: {props.adminState.dataAnswersId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(props.adminState.selectedId))
                //{ console.log(item.text)}
                {return item.text;} else return null;
                })}
                </p>



             
             <form>
                 <label>
                     Новый текст в боксе:</label>
                 <textarea  onChange={handleUserInputContent} 
                 ></textarea>
                 

                 <label>
                     Правдивое утверждение(100/0-да/нет)</label>
                 <input onChange={handleUserInputValue}  />
                 

                

             </form>
             <button onClick={onSend}>OK</button>
             <button onClick={onClose}>Закрыть</button>
            </div>
        )
      
    
}
export default InputFormsForAnswersType3;